import type { ReactNode } from 'react'

const productNames = { contextful: 'Contextful', forge: 'Forge', vhoop: 'VHoop', admin: 'Contextful Admin' } as const
export type BrandProduct = keyof typeof productNames

/** One family of marks, with a distinct silhouette for each product. */
export function ProductBrand({ product, compact = false }: { product: BrandProduct; compact?: boolean }) {
  return (
    <span className={`product-brand product-brand--${product}`}>
      <svg className="product-brand-mark" viewBox="0 0 32 32" fill="none" aria-hidden="true">
        {product === 'contextful' && <><path d="M24 7a12 12 0 1 0 0 18M10 16h16M16 10v12" stroke="currentColor" strokeWidth="2.5" /><circle cx="26" cy="16" r="3" fill="currentColor" /></>}
        {product === 'forge' && <><path d="M7 26V6h20M7 15h15" stroke="currentColor" strokeWidth="3" /><path d="m17 23 4 4 7-8" stroke="currentColor" strokeWidth="2.5" /></>}
        {product === 'vhoop' && <><path d="m4 7 12 21L28 7" stroke="currentColor" strokeWidth="3" /><circle cx="16" cy="9" r="4" stroke="currentColor" strokeWidth="2" /></>}
        {product === 'admin' && <><rect x="5" y="5" width="22" height="22" rx="3" stroke="currentColor" strokeWidth="2" /><path d="M12 5v22M12 13h15M20 13v14" stroke="currentColor" strokeWidth="2" /></>}
      </svg>
      {!compact && <span>{productNames[product]}</span>}
    </span>
  )
}

export function ServiceFeatures({ children }: { children: ReactNode }) {
  return <div className="service-features">{children}</div>
}
